<template>
  <div class="preview-consumer">
    <div class="collapsed-preview">
      <img class="bg-image" src="/assets/img/iphone_6.png" />
      <img class="map-image" src="/assets/img/map.png" />
      <div class="collapsed">
        <div class="service-background">
          <div class="icon">
            <img :src="details.image" alt="service img">
          </div>
          <div class="name">{{details.name}}</div>
          <div class="short-desc">{{ details.excerptApp }}</div>
          <div class="ammenities">
            <i class="fas fa-user"></i>
            <span>{{details.maxPassengers}} max</span>
            <i class="fas fa-briefcase"></i>
            <span>{{details.maxLuggages}} max</span>
          </div>
          <div class="price">
            <span class="value">$10.00</span>
          </div>
        </div>
      </div>
    </div>
    <div class="expanded-preview">
      <img class="bg-image" src="/assets/img/iphone_6.png" />
      <img class="map-image" src="/assets/img/map.png" />
      <div class="expanded">
        <img :src="details.image" alt="service img" class="car">
        <div class="service-selected">{{details.name}}</div>
        <div class="title">{{ details.slogan }}</div>
        <div class="row pax-luggage">
          <div class="col">
            <i class="fas fa-user fa-2x"></i>
            <div>
              <span class="label">Passenger</span>
              <span class="value">{{details.maxPassengers}} max</span>
            </div>
          </div>
          <div class="col">
            <i class="fas fa-briefcase fa-2x"></i>
            <div>
              <span class="label">Luggage</span>
              <span class="value">{{details.maxLuggages}} max</span>
            </div>
          </div>
        </div>
          <div class="description">
            {{ details.descriptionApp }}
          </div>
          <div class="advance">
            <i>{{ details.advantageApp }}</i>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['details'],
  name: 'preview-consumer'
}
</script>

<style lang="scss" scoped>
.preview-consumer {
  margin-top: 15px;
  .collapsed-preview {
    position: relative;
    display: inline-block;

    .bg-image {
      width: 300px;
      display: block;
    }
    .map-image {
      position: absolute;
      top: 76px;
      left: 22px;
      width: 259px;
      height: 461px;
    }
    .collapsed {
      position: absolute;
      bottom: 125px;
      left: 32px;
      width: 239px;
      border-radius: 7px;
      background-color: #fff;
      display: block;
      text-align: center;
      -webkit-transition: all 350ms ease;
      transition: all 350ms ease;
      padding: 4px;
      background-color: #fff;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);
      background-color: #009688 !important;
      color: #777;
      margin-bottom: 5px;

      .service-background {
        position: relative;
        background-color: #fff;
        border-radius: 4px;
        padding: 6px;

        .icon {
          position: relative;
          width: 50px !important;
          height: 50px !important;
          margin-bottom: 5px !important;

          img {
            position: absolute;
            top: 0;
            left: 0;
            height: 50px !important;
          }
        }

        .name {
          position: absolute;
          font-weight: 700;
          color: #009688 !important;
          left: 62px !important;
          top: 2px !important;
          font-size: 13px !important;
        }

        .short-desc {
          position: absolute;
          font-weight: 300;
          left: 62px !important;
          top: 16px !important;
          font-size: 12px !important;
        }

        .ammenities {
          position: absolute;
          font-weight: 400;
          left: 62px !important;
          top: 31px !important;
          font-size: 9px !important;

          span {
            margin-right: 5px;
            display: inline-block;
          }
        }

        .price {
          position: absolute;
          font-weight: 900;
          color: #333;
          text-align: right;
          right: 10px;
          top: 14px !important;
          font-size: 15px !important;
          color: #009688;
        }
      }
    }
  }
  .expanded-preview {
    position: relative;
    display: inline-block;
    .bg-image {
      width: 300px;
      display: block;
    }
    .map-image {
      position: absolute;
      top: 76px;
      left: 22px;
      width: 259px;
      height: 461px;
    }
    .expanded {
      position: absolute;
      top: 190px;
      left: 22px;
      background-color: #fff;
      text-align: center;
      padding-bottom: 60px;
      border: 1px solid #ccc;
      width: 260px;
      margin: 0% auto;
      font-family: 'Work Sans', sans-serif;
      color: #1f1f21;
      height: 348px;
      overflow-y: auto;

      .car {
        margin: 20px 0 20px;
        width: 30%
      }
      
      .service-selected {
        display: block;
        position: relative;
        bottom: 10px;
      }

      .title {
        font-size: 18px;
        padding: 0 5px;
        margin-bottom: 20px;
        font-weight: 600;
      }

      .pax-luggage {
        margin-bottom: 20px;
        padding: 0 10px;
        display: -moz-flex;
        display: -ms-flexbox;
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        box-sizing: border-box;

        .col {
          -webkit-box-flex: 1;
          -webkit-flex: 1;
          -moz-box-flex: 1;
          -moz-flex: 1;
          -ms-flex: 1;
          flex: 1;
          display: block;
          width: 100%;
          box-sizing: border-box;

          div {
            display: inline-block;
            text-align: left;
            margin-left: 5px;

            .label {
              font-size: 13px;
              // color: #999;
              display: block;
            }
          } 
        }
      }

      .description {
        text-align: left;
        font-size: 14px;
        // color: #999;
        line-height: 150%;
        padding: 0 15px;
        margin-bottom: 20px;
      }

      .advance {
        text-align: left;
        font-size: 14px;
        // color: #999;
        line-height: 150%;
        padding: 0 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Services/PreviewConsumer.vue